/** Artifact phases from GET /remediation/requests/{id}/artifacts/{phase} (OpenAPI). */

export const ARTIFACT_PHASE_ORDER = [
  "preview/pre",
  "preview/playbook",
  "exec/pre",
  "exec/post",
  "exec/aws_responses",
];

export const ARTIFACT_PHASE_LABELS = {
  "preview/pre": "Preview — pre",
  "preview/playbook": "Preview — playbook",
  "exec/pre": "Execution — pre",
  "exec/post": "Execution — post",
  "exec/aws_responses": "Execution — AWS responses",
};

export const getArtifactPhaseLabel = (phase) =>
  ARTIFACT_PHASE_LABELS[phase] || phase || "Unknown phase";

/** Sort manifest phases in canonical API order; unknown phases last. */
export const sortArtifactPhases = (phases = []) => {
  const rank = new Map(ARTIFACT_PHASE_ORDER.map((p, i) => [p, i]));
  return [...phases].sort((a, b) => {
    const ra = rank.has(a.phase) ? rank.get(a.phase) : 999;
    const rb = rank.has(b.phase) ? rank.get(b.phase) : 999;
    if (ra !== rb) return ra - rb;
    return String(a.phase).localeCompare(String(b.phase));
  });
};

export const formatArtifactBytes = (bytes) => {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
